/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { FunctionComponent } from 'react';
import {
  EuiHeader,
  EuiHeaderSection,
  EuiHeaderSectionItem,
  EuiText,
} from '@elastic/eui';
import { useRouter } from 'next/router';
import { UserMenu } from './UserMenu';
import { useUiChrome } from './useUiChrome';

/**
 * Fixed brand bar (primary header). Branding + UserMenu only — the
 * burger toggle and page actions live in the secondary Toolbar
 * below this bar, not here.
 */
export const TopBar: FunctionComponent = () => {
  const router = useRouter();
  const { isPhone } = useUiChrome();

  return (
    <EuiHeader theme="dark" position="fixed" className="app-shell-header">
      <EuiHeaderSection side="left">
        <EuiHeaderSectionItem>
          <img
            onClick={() => router.push('/')}
            style={{ cursor: 'pointer' }}
            src="/images/blue-heart-white-text-small.png"
            alt="DA Logo"
            width="50px"
          />
        </EuiHeaderSectionItem>
        {/* Brand text + divider: hidden on phone (xs) to keep the bar compact. */}
        {!isPhone && (
          <EuiHeaderSectionItem>
            <EuiText
              size="m"
              color="white"
              css={{
                marginLeft: '10px',
                paddingLeft: '10px',
                opacity: 0.6,
                borderLeft: '1px solid #ffffff50',
              }}>
              <strong>Campaign Manager</strong>
            </EuiText>
          </EuiHeaderSectionItem>
        )}
      </EuiHeaderSection>

      <EuiHeaderSection side="right">
        <EuiHeaderSectionItem>
          <UserMenu />
        </EuiHeaderSectionItem>
      </EuiHeaderSection>
    </EuiHeader>
  );
};

export default TopBar;
